import React from "react";
import BaseSelect from "../BaseSelect";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    root: {
        width: "355px",

        [theme.breakpoints.down(370)]: {
            width: "240px",
        },
        [theme.breakpoints.between(370, 430)]: {
            width: "290px",
        },
        [theme.breakpoints.between(430, 500)]: {
            width: "305px",
        },
    },
}));

const Select  = (props) => {
    const styles = useStyles();
    return (
        <BaseSelect
            classes={styles}
            {...props}
        />
    );
};

export default Select;
